import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

import { PriceAndSaleInfo } from '../PriceAndSaleInfo/PriceAndSaleInfo';
import { useBiddingSection } from '../useBiddingSection';
import { useHasValuationsToDisplay } from '../Valuations/useHasValuationsToDisplay';
import { Valuations } from '../Valuations/Valuations';

import { BuyItNowCTA } from './BuyItNowCTA';

import styles from './BuyItNow.module.scss';

export const BuyItNow: React.FC = () => {
	const isBinExpiryVisibilityEnabled = useFeatureToggle(FEATURES.binExpiryVisibility);
	const { isOwnedByUserDealership } = useBiddingSection();
	const hasValuationsToDisplay = useHasValuationsToDisplay();

	return (
		<>
			<PriceAndSaleInfo badgeVariant={isBinExpiryVisibilityEnabled ? 'binCountdown' : undefined} />
			{hasValuationsToDisplay ? <Valuations /> : null}
			{/* BuyItNowCTA only appears here on desktop and tablet */}
			{!isOwnedByUserDealership ? (
				<div className={styles.hideOnMobileWrapper}>
					<BuyItNowCTA />
				</div>
			) : null}
		</>
	);
};
